/**
 * Language Switcher Component
 * Allows users to switch between Uzbek, Russian, and English
 */

import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();

  const languages = [
    { code: 'uz', label: t('language.uz') },
    { code: 'ru', label: t('language.ru') },
    { code: 'en', label: t('language.en') },
  ];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => handleLanguageChange(lang.code)}
          style={{
            padding: '8px 16px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            backgroundColor: i18n.language === lang.code ? '#01178E' : 'white',
            color: i18n.language === lang.code ? 'white' : '#333',
            cursor: 'pointer',
            fontWeight: i18n.language === lang.code ? 'bold' : 'normal',
          }}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
